import Axios from "axios";

const apiInstance = Axios.create();

apiInstance.interceptors.response.use(
  response => response,
  err => {
    if (err.response.status === 403 && err.response.data?.message !== "comment_moderated") {
      return Promise.reject(new Error("sessionExpired"));
    }
    if (!err.response.data.message) {
      return Promise.reject(new Error("internalError"));
    }
    // Instead of creating a new Error with just the message,
    // preserve the full axios error so we can access response data
    return Promise.reject(err);
  }
);

export default apiInstance;
